module.exports = __webpack_public_path__ + "img/step2.49d1df84.png";